<template>
    <kgr-form-scaffold
        :pending="pending"
        @primaryBtnClicked="addField"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-field-create-form
            :field="field"
            :error="error"
            @enter="addField"
        />
    </kgr-form-scaffold>
</template>

<script>

import Area from '../../js/dto/resource/Area';
import Error from '../../js/model/Error';
import Field from '../../js/dto/resource/Field';
import FieldBasicDataForm from '../../components/resource/FieldBasicDataForm';
import FieldRepository from '../../js/repository/FieldRepository';
import FormScaffold from '../../components/common/form/FormScaffold';
import Location from '../../js/dto/resource/Location';

export default {
    components: {
        'kgr-field-create-form': FieldBasicDataForm,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        areaId: {
            type: String,
            required: true,
        },
        locationId: {
            type: String,
            required: true,
        },
        overviewUrl: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            field: new Field(),
            area: new Area(),
            location: new Location(),
            error: new Error()
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onFieldLoaded(loadedField) {
            this.field = loadedField;
        },
        addField() {
            if (this.pending) {
                return;
            }

            this.pending = true;

            FieldRepository.create(this.field,  this.areaId, this.locationId)
                .then(id => {
                    this.$notify.success('field.created', {}, { saveInSession: true });
                    window.location = `/backend/resources/locations/${this.locationId}/areas/${this.areaId}/fields/${id}/edit`;
                })
                .catch(error => {
                    this.handleError(error);
                    this.pending = false;
                });
        },
        handleError(error) {
            this.error = error;
            this.$notify.error('saveChanges.error');
        },
    },
}



</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
